import { useGetQuickshareDetails } from 'lib/api/quickshare/useGetQuickshareDetails';
import { useGetVideos } from 'lib/api/videos/useGetVideos';
import { LoadingIndicator } from 'lib/components';
import React from 'react';
import SearchAndFolders from '../../SearchAndFolders';
import {
  EmptyFiles,
  FilesItem,
  FilesItemDate,
  FilesItemThumbnail,
  FilesItemTitle,
  FilesSelector,
  ItemTypeValues,
  Menu,
  Row,
} from './Components';
import { ISelectedFile } from 'app/pages/conversations/forms/sms';
import { Button } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';

type Props = {
  searchQuery: string;
  handleSearch(search: string): void;
  handleModalClose: () => void;
  onSelect: (item: ISelectedFile, itemType: string) => void;
};

export const VideosTab = (props: Props) => {
  const { t } = useTranslation();
  const { searchQuery, handleSearch, handleModalClose, onSelect } = props;

  const videoFilter = {
    videoType: '',
    advisorId: '',
    userId: '',
    status: '',
    emailStatus: '',
    folderId: 0,
    page: 0,
    size: 1000,
    searchQuery,
  };

  const { data, isLoading: loading } = useGetVideos(videoFilter, '');
  const videos = data?.videos || [];
  const [selectedVideoId, setSelectedVideoId] = React.useState<string | number>(
    ''
  );

  const { data: quickshareDetails, refetch } = useGetQuickshareDetails({
    videoId: selectedVideoId,
    enabledOnMount: false,
  });

  React.useEffect(() => {
    if (selectedVideoId) {
      refetch();
    }
  }, [selectedVideoId, refetch]);

  React.useEffect(() => {
    if (quickshareDetails) {
      handleModalClose();
      onSelect(quickshareDetails.data, ItemTypeValues.VIDEO);
    }
  }, [quickshareDetails, handleModalClose, onSelect]);

  return (
    <>
      <Menu>
        <Row>
          <SearchAndFolders
            handleSearch={handleSearch}
            handleEmptySearch={() => {}}
            onSelectFolder={() => null}
            searchDisabled={false}
          />
        </Row>
      </Menu>
      {loading && <LoadingIndicator isLoading={loading} height='200px' />}
      {!loading && (
        <FilesSelector>
          {videos.map(video => (
            <FilesItem
              key={video.id}
              onClick={() => setSelectedVideoId(video.id)}
            >
              <FilesItemThumbnail image={video.thumbnail} />
              <FilesItemTitle>
                {video.title} <br />
                <FilesItemDate>{video.recordDate}</FilesItemDate>
              </FilesItemTitle>
              <Button text={t('Select Video')} variant='secondary' />
            </FilesItem>
          ))}
          {!videos.length && <EmptyFiles>{t('No videos found.')}</EmptyFiles>}
        </FilesSelector>
      )}
    </>
  );
};
